import { ChevronLeft, ChevronRight } from 'lucide-react'

import { Button } from '@/components/ui/button'
import { cn } from '@/lib/utils'

import { SidebarThemes } from '../types'

interface SidebarToggleButtonProps {
  isSidebarOpen: boolean
  onToggle: () => void
  ariaLabel: string
  theme?: SidebarThemes
}

export const SidebarToggleButton = ({
  isSidebarOpen,
  onToggle,
  ariaLabel,
  theme = 'light',
}: SidebarToggleButtonProps) => {
  return (
    <Button
      variant={theme === 'dark' ? 'botEnvironment' : 'outline'}
      className={cn(
        'absolute bottom-24 right-[-0.9rem] z-10 h-8 w-8 rounded-full p-0 text-muted-foreground [&_svg]:h-6 [&_svg]:w-6',
        theme === 'dark' && 'bg-sidebar-close-open-button-background',
      )}
      aria-label={ariaLabel}
      onClick={onToggle}
    >
      {isSidebarOpen ? <ChevronLeft /> : <ChevronRight />}
    </Button>
  )
}
